import { motion } from "framer-motion";
import Avatar from "../components/avatar";
import DateComponent from "../components/date";
import CoverImage from "../components/cover-image";
import PostTitle from "../components/post-title";

export default function PostHeader({
  title,
  coverImage,
  date,
  tags,
  description,
}) {
  return (
    <>
      <motion.div
        className="relative mb-8 lg:mb-12 -ml-5 -mr-5 md:mx-0"
        initial={{ opacity: 0, top: 120 }}
        whileInView={{
          opacity: 1,
          top: 0,
        }}
        viewport={{ once: true }}
      >
        <CoverImage title={title} url={coverImage.url} />
      </motion.div>
      <motion.div
        className="relative max-w-4xl w-100 mx-auto"
        initial={{ opacity: 0, top: 40 }}
        whileInView={{ opacity: 1, top: 0 }}
        viewport={{ once: true }}
      >
        <PostTitle>{title}</PostTitle>
        <div className="flex justify-between align-bottom mb-8">
          <p className="project-description text-2xl">{description}</p>
          <div className="text-sm md:text-md lg:text-lg">
            <DateComponent dateString={date} />
          </div>
        </div>

        <p className="text-base uppercase leading-relaxed mb-4">
          {tags.map((tag) => (
            <span className="tag" key={tag}>
              {tag}
            </span>
          ))}
        </p>
        <hr />
      </motion.div>

      <div className="max-w-2xl mx-auto">
        {/* <div className="block md:hidden mb-6">
          {author && <Avatar name={author.name} picture={author.image} />}
        </div> */}
      </div>
    </>
  );
}
